var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCursor = function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cursor_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.956 8.6C6.103 8.6 3.744 1.893 4.773.768c1.07-1.138 7.022 2.4 6.79 5.35-.097 1.316-1.414 2.51-2.607 2.482ZM7.708 23.77c-1.454 1.96-6.954.383-7.16-.865-.192-1.275 5.13-3.676 6.899-2.126.81.7.892 2.167.26 2.99Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.835 26.032c-2.099.179-4.101-.836-5.02-2.578-1.29-2.442.233-4.91.48-5.28 1.399-2.195 3.8-2.58 4.183-2.634-3.497-2.263-4.869-6.117-3.676-8.943.686-1.604 2.373-3.237 4.609-3.415 2.55-.192 5.06 1.591 5.897 4.334a7.439 7.439 0 0 1 4.239.316c2.455.932 3.62 2.853 3.922 3.415a6.56 6.56 0 0 1 1.81.521c2.36 1.056 3.444 3.182 4.033 4.334 2.4 4.732.343 11.933.206 12.4-3.333 11.74-5.637 18.09-8.037 23.412a3.577 3.577 0 0 1-2.552 2.044c-2.276.466-6.076.768-10.067-1.084-2.332-1.083-4.1-1.783-5.047-3.744-.782-1.619-.801-3.13-.467-4.142 1.084-3.279 2.14-6.68 3.155-10.219a324.794 324.794 0 0 0 2.332-8.736Z",
    fill: "#000",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.359 12.906c-1.481.467-3.114-.7-3.813-1.988-.754-1.386-.754-3.54.576-4.485 1.468-1.07 4.019-.234 4.924 1.577.919 1.797.041 4.361-1.687 4.896ZM8.298 23.042c-.988-.987-.618-2.853.315-3.868.74-.822 2.195-1.467 3.415-.822.837.452 1.317 1.357 1.345 2.221.054 1.784-1.825 2.675-1.92 2.716-.824.357-2.291.617-3.155-.247Z",
    fill: "#fff",
    stroke: "#0B0A0A",
    strokeWidth: 0.153,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.816 19.188c-1.234.576-1.906 1.824-1.687 2.922.26 1.234 1.591 1.92 2.565 1.947 1.083.028 1.371-.74 2.798-.768.782-.014 1.371.206 1.906.412 1.633.617 1.701 1.344 2.95 1.66.301.068 1.81.452 2.633-.467.562-.617.63-1.618.246-2.565",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.816 19.188c-1.234.576-1.906 1.824-1.687 2.922.26 1.234 1.591 1.92 2.565 1.947 1.083.028 1.371-.74 2.798-.768.782-.014 1.371.206 1.906.412 1.633.617 1.701 1.344 2.95 1.66.301.068 1.81.452 2.633-.467.562-.617.63-1.618.246-2.565",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.816 19.188c-1.234.576-1.906 1.824-1.687 2.922.26 1.234 1.591 1.92 2.565 1.947 1.083.028 1.371-.74 2.798-.768.782-.014 1.371.206 1.906.412 1.633.617 1.701 1.344 2.95 1.66.301.068 1.81.452 2.633-.467.562-.617.63-1.618.246-2.565",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.458 12.385c-.26.206-1.33 1.139-1.55 2.73-.178 1.316.316 2.414.728 3.003 1.22 1.742 4.046 2.36 6.926 1.345",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.458 12.385c-.26.206-1.33 1.139-1.55 2.73-.178 1.316.316 2.414.728 3.003 1.22 1.742 4.046 2.36 6.926 1.345",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.458 12.385c-.26.206-1.33 1.139-1.55 2.73-.178 1.316.316 2.414.728 3.003 1.22 1.742 4.046 2.36 6.926 1.345",
    stroke: "#fff",
    strokeWidth: 0.153,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.029 15.128c-.275.37-.768 1.125-.782 2.126-.041 1.907 1.66 3.676 3.58 4.02 1.837.342 3.278-.742 3.58-.975",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.029 15.128c-.275.37-.768 1.125-.782 2.126-.041 1.907 1.66 3.676 3.58 4.02 1.837.342 3.278-.742 3.58-.975",
    stroke: "#fff",
    strokeWidth: 1.097,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.029 15.128c-.275.37-.768 1.125-.782 2.126-.041 1.907 1.66 3.676 3.58 4.02 1.837.342 3.278-.742 3.58-.975",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cursor_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h33v54.863H0z"
  })))));
};

export default SvgCursor;